import { patientApi } from '@/core/api/patient'

export const {
  useCreatePatientMutation,
  useGetPatientQuery,
  useUpdatePatientMutation,
  useListPatientsQuery,
  useLazyListPatientsQuery,
  useLazyGetPatientQuery,
  useLazyGetPatientConsultationsQuery,
  useGetPatientFilesQuery,
  useMergePatientsMutation,
  useGetOrCreateOrdoclicPatientQuery,
  useLazyGetOrCreateOrdoclicPatientQuery,
  useGetOrCreateDesmosPatientQuery,
  useLazyGetOrCreateDesmosPatientQuery,
  useSearchPatientsQuery,
  useSearchInsIdentityPatientsQuery,
  useLazySearchInsIdentityPatientsQuery,
  useLazySearchUnassignedPatientsQuery,
  useGetPatientConsultationsQuery,
  useAttachPatientToEstablishmentMutation,
  useLazyLookupPatientByInsNIRQuery,
} = patientApi
